const channelsList = [
  { name: 'Google RBM', code: 'rbm' },
  { name: 'Web & Socket API', code: 'socket' },
  { name: 'Facebook', code: 'messenger' },
  { name: 'RocketChat', code: 'rocketchat' },
  { name: 'LivePerson', code: 'liveperson' },
  { name: 'Khoros', code: 'khoros' },
  { name: 'Mavenir', code: 'mavenir' },
  { name: 'Telekom', code: 'telekom' },
  { name: 'Telegram', code: 'telegram' },
  { name: 'Twilio', code: 'twilio' },
  { name: 'Twitter', code: 'twitter' },
  { name: 'Slack', code: 'slack' },
  { name: 'MessageMedia', code: 'messagemedia' },
  { name: 'Viber', code: 'viber' },
  { name: 'Sparkcentral', code: 'sparkcentral' },
  { name: 'Wit', code: 'wit' },
  { name: 'Front', code: 'front' },
  { name: 'Rest', code: 'rest' },
  { name: 'Kik', code: 'kik' },
  { name: 'Apple Business Chat', code: 'apple' },
  { name: 'SDK', code: 'socket_sdk' },
  { name: 'WhatsApp', code: 'whatsapp' }
]

export default channelsList
